<template>
    <v-dialog 
        v-model="dialog" 
        width="600" 
        @click:outside="closeModal"
    >
        <v-card class="custom-card pb-120" rounded="0">
            <!-- <v-toolbar color="secondary" flat class="white--text">
                <v-toolbar-title class="font-weight-bold"> djfglkd</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-btn icon class="white--text" @click="closeModal">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar> -->
            <v-card-text class="py-1 px-1">
                <div class="google-map" style="width:100%;height:540px; z-index: 0;"  id="map" ref="googleMap"></div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
    import { Loader } from '@googlemaps/js-api-loader';
    export default {
        async mounted() {
            this.mapOptions.center.lat = this.lat;
            this.mapOptions.center.lng = this.lng;
            try {
                const loader = await new Loader({
                    apiKey: "AIzaSyBxEppGyQ3YatmT9C8RJjXAh9HsVtpKLh4",
                    libraries: ["places", "map"]
                }).load()
                .then((google) => {
                    this.google = google;
                    this.initializeMap(google);
                })
                .catch(e => {
                    console.log('Map', e);
                });
                this.loader = loader;
            
            }catch(e) {
                console.log(e);
            }
        },
        computed: {
            dialog() {
                return this.dialogU;
            }
        },
        data() {
            return {
                loader: null,
                google: null,
                mapOptions: {
                    mapTypeId: 'satellite',
                    center: {

                    },
                    styles: {
                        overflow: 'visible'
                    },
                    zoom: 18,
                    disableDefaultUI: true
                },
                latitude: 0,
                longitude: 0,
            };
        },
        methods: {
            closeModal() {
                this.$emit("dialog-closed");
            },
            async initializeMap(google) {
                this.google = google;
                const mapContainer = this.$refs.googleMap
                this.map = await new google.maps.Map(mapContainer, this.mapOptions);
                this.createPolygon()
            },
            async createPolygon() {
                if(this.polygon != null) this.polygon.setMap(null);
                this.polygon = await  new this.google.maps.Polygon({
                    paths: this.polygonCoords,
                    strokeColor: "#1F5D51",
                    strokeOpacity: 0.8,
                    strokeWeight: 3,
                    fillColor: "#E5F8F1",
                    fillOpacity: 0.7,
                    editable: false,
                    draggable: false,
                    icon: this.google.maps.SymbolPath.BACKWARD_CLOSED_ARROW
                });
          
                this.polygon.setMap(this.map);
                return Promise.resolve(true)

            },
        },
        props: {
            dialogU: {
                type: Boolean,
                required: true,
            },
            polygonCoords: {
                required: true
            },
            lat: {
                required: false
            },
            lng: {
                required: false
            }
        }
    };
  </script>